module.exports = __webpack_public_path__ + "static/img/eLogo.b15571cc.png";